var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowdecrease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.234234 0.234234C0.38426 0.0842543 0.58771 0 0.799846 0C1.01198 0 1.21543 0.0842543 1.36546 0.234234L5.48315 4.35112L7.31679 2.51668C7.354 2.47956 7.39817 2.45014 7.44676 2.4301C7.49536 2.41005 7.54743 2.39979 7.59999 2.39988C7.65245 2.39967 7.70441 2.41001 7.75279 2.43028C7.82595 2.46052 7.88848 2.51178 7.93249 2.57757C7.97649 2.64336 7.99999 2.72074 8 2.79989V7.59999C8 7.70608 7.95786 7.80782 7.88284 7.88284C7.80782 7.95786 7.70608 8 7.59999 8H2.79989C2.72067 8.00014 2.64319 7.97676 2.57728 7.93281C2.51137 7.88887 2.45999 7.82634 2.42965 7.75316C2.39932 7.67998 2.3914 7.59945 2.40689 7.52176C2.42238 7.44407 2.4606 7.37273 2.51668 7.31678L4.35112 5.48315L0.234234 1.36546C0.0842541 1.21543 0 1.01198 0 0.799846C0 0.58771 0.0842541 0.38426 0.234234 0.234234Z",
    fill: "#FF3A44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdecrease);
export default __webpack_public_path__ + "static/media/arrowdecrease.0ab8a035c2ebb1b9053922b04ba3e993.svg";
export { ForwardRef as ReactComponent };